var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCricketPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-558.000000, -473.000000)",
    fill: "#8225FA"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(553.000000, 468.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7083333,25.6583667 C5.7633342,25.6583667 0.1333,20.0283325 0.1333,13.0833333 C0.1333,6.1383342 5.7633342,0.5083 12.7083333,0.5083 C19.6533325,0.5083 25.2833667,6.1383342 25.2833667,13.0833333 C25.2833667,20.0283325 19.6533325,25.6583667 12.7083333,25.6583667 Z M12.7083333,24.0499667 C18.7650377,24.0499667 23.6749667,19.1400377 23.6749667,13.0833333 C23.6749667,7.02662899 18.7650377,2.1167 12.7083333,2.1167 C6.65162899,2.1167 1.7417,7.02662899 1.7417,13.0833333 C1.7417,19.1400377 6.65162899,24.0499667 12.7083333,24.0499667 Z",
    id: "Oval",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "2.33948861 18.7561553 1.20217806 17.6188447 16.7230114 2.09801139 17.8603219 3.23532194"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillRule: "nonzero",
    points: "8.17282194 24.5894886 7.03551139 23.4521781 22.5563447 7.93134473 23.6936553 9.06865527"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCricketPurple);
export default __webpack_public_path__ + "static/media/cricketPurple.73470737e1d7e8a3fc6eb67dd9ae59a5.svg";
export { ForwardRef as ReactComponent };